export default "__VITE_ASSET__0080eed7__"